import { z } from 'zod/v4';

// Polterabend-specific person schema
export const PolterabendPersonSchema = z.object({
    name: z.string().min(1, 'Name ist erforderlich').max(100, 'Name zu lang'),
    attendsWedding: z.boolean().default(false),
    attendsPolterabend: z.boolean().default(false),
    attendsNothing: z.boolean().default(false),
    allergies_comments: z.string().max(500, 'Kommentar zu lang').optional(),
    // Polterabend-specific fields
    brings_items: z.string().max(300, 'Mitbringen-Text zu lang').optional(), // Was wird mitgebracht
    dietary_requirements: z.string().max(300, 'Diätanforderungen zu lang').optional()
});

export const PolterabendRSVPSchema = z.object({
    email: z.email('Ungültige Email-Adresse'),
    wants_updates: z.boolean().default(true),
    persons: z.array(PolterabendPersonSchema).min(1, 'Mindestens eine Person erforderlich').max(15, 'Maximal 15 Personen'),
    additional_notes: z.string().max(1000, 'Notizen zu lang').optional(),
    // Polterabend-specific fields
    arrival_time: z.enum(['early', 'ontime', 'late']).default('ontime'), // Ankunftszeit
    event_type: z.literal('polterabend') // To distinguish from wedding RSVP
});

// TypeScript Types
export type PolterabendPerson = z.infer<typeof PolterabendPersonSchema>;
export type PolterabendRSVP = z.infer<typeof PolterabendRSVPSchema>;